import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
} from "reactstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Breadcrumb from "../../components/Common/Breadcrumb";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../helpers/forms_helper";
import moment from "moment";
import printDiv from "../../helpers/print_data";
import showNotification from "../../helpers/show_notification";
import preloader from "../../helpers/preloader";
import {
  ExportAvailableInCSVForReports,
  exportFromula,
  formatUnitsForReport,
  mapUnits,
} from "../../helpers/units";

const DebugPage = (props) => {
  const { SearchBar } = Search;
  const [selectedBranch, setSelectedBranch] = useState("");
  const [allBranches, setAllBranches] = useState([]);
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [isOpeningBalance, setIsOpeningBalance] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [response, setResponse] = useState();
  const [flattenedData, setFlattenedData] = useState([]);
  const [debugType, setDebugType] = useState("");
  const handleDebugTypeChange = (e) => {
    const newType = e.target.value;
    setDebugType(newType);

    setSelectedMethod("");
    // setSelectedBranch("");
    // setDateFrom(moment().startOf('month').format('YYYY-MM-DD'));
    // setDateTo(moment().format('YYYY-MM-DD'));
    setAllOrders([]);
    setFlattenedData([]);
  };
  function afterFilter(newResult, newFilters) {
    setFlattenedData((prevOrders) => {
      return JSON.stringify(prevOrders) !== JSON.stringify(newResult)
        ? newResult
        : prevOrders;
    });
  }
  useEffect(() => {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1,
    );

    const formattedFirstDay = moment(firstDayOfMonth).format("YYYY-MM-DD");
    const formattedCurrentDay = moment(currentDate).format("YYYY-MM-DD");

    setDateFrom(formattedFirstDay);
    setDateTo(formattedCurrentDay);
    loadAllBranches();
  }, []);

  const [allOrders, setAllOrders] = useState([]);
  const loadOrders = async (e, v) => {
    const start = moment(dateFrom);
    const end = moment(dateTo);
    const daysDiff = end.diff(start, "days");
    if (Number(v.opening_balance_price_total) > 0) {
      setIsOpeningBalance(true);
    } else {
      setIsOpeningBalance(false);
    }
    if (daysDiff > 31) {
      showNotification("Date range cannot exceed 31 days", "Warning");
      return false;
    }

    if (daysDiff < 0) {
      showNotification("End date cannot be before start date", "Warning");
      return false;
    }

    preloader(true);
    let endPoint =
      debugType === "product"
        ? "inventory_product_transaction_details"
        : "inventory_transaction_details";
    let url = process.env.REACT_APP_BASEURL + `reports/${endPoint}`;
    const response = await postSubmitForm(url, {
      store_id: selectedBranch,
      date_from: moment(dateFrom).format("YYYY-MM-DD"),
      date_to: moment(dateTo).format("YYYY-MM-DD"),
      method: v.method,
      opening_balance_price_total: v.opening_balance_price_total,
    });
    setFlattenedData([]);
    setAllOrders([]);
    if (response && response.status === 1) {
      preloader(false);
      setResponse(response.data);
      setAllOrders(response.data?.transactions);
      setFlattenedData(response.data?.transactions);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  const loadAllBranches = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      let res = response.data;
      setAllBranches(res);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const getUniqueTransactionTypes = () => {
    const types = [
      ...new Set(allOrders?.map((item) => item.transaction_type)),
    ].filter(Boolean);
    return types.map((type) => ({
      value: type,
      label: type,
    }));
  };
  const columns = [
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      footer: true,
    },
    {
      dataField: debugType === "product" ? "product_name" : "item_name",
      text: props.t(debugType === "product" ? "Product Name" : "Item Name"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
          >
            {debugType === "product" ? row.product_name : row.item_name}
            {row.is_free && (
              <span className="text-danger ms-1" style={{ fontSize: "20px" }}>
                *
              </span>
            )}
          </span>
        );
      },
      footer: true,
      headerStyle: { width: "15%" },
    },
    {
      dataField: "batch",
      text: props.t("Batch"),
      sort: true,
      footer: true,
      headerStyle: { width: "8%" },
    },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      footer: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: { width: "12%" },
    },

    {
      dataField: "transaction_quantity",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.transaction_quantity);
      },
      footer: true,
      headerStyle: { width: "12%" },
    },
    {
      dataField:
        debugType === "product" ? "unit_for_cost_price" : "unit_for_po",
      text: props.t(
        debugType === "product" ? "Unit For Costing" : "Purchasing Unit",
      ),
      sort: true,
      footer: true,
      headerStyle: { width: "7%" },
    },
    {
      dataField: "cost_price",
      text: props.t("Cost Price"),
      formatter: (cell) => (cell ? `${cell.toFixed(2)}` : "-"),
      sort: true,
      footer: true,
      headerStyle: { width: "7%" },
    },
    {
      dataField: "receiving_cost",
      text: props.t("Receiving Cost"),
      formatter: (cell) => (cell ? `${cell.toFixed(2)}` : "-"),
      sort: true,
      headerStyle: { width: "7%" },
      footer: (columnData) =>
        columnData.reduce((acc, item) => Number((acc + item).toFixed(2)), 0),
    },
    {
      dataField: "transaction_date",
      text: props.t("Transaction Date"),
      formatter: (cell) => moment(cell).format("DD/MM/YYYY HH:mm:ss"),
      sort: true,
      footer: true,
      headerStyle: { width: "7%" },
    },
    {
      dataField: "transaction_type",
      text: props.t("Type"),
      formatter: (cell, row) => {
        try {
          if (!cell?.length) return "-";
          return (
            <>
              {row.transaction_type && (
                <small
                  style={{
                    color:
                      row.transaction_type === "Credit" ? "#28a745" : "#dc3545",
                    fontSize: "11px",
                    fontWeight: "bold",
                  }}
                >
                  {row.transaction_type}
                </small>
              )}
            </>
          );
        } catch (error) {
          console.error("Error formatting quantities:", error);
          return "Invalid Quantity";
        }
      },
      filter: selectFilter({
        options: ({ data }) => getUniqueTransactionTypes(),
        placeholder: "Select Type",
        className: "custom-select",
        withoutEmptyOption: false,
      }),
      sort: true,
      footer: true,
      headerStyle: { width: "7" },
    },
    {
      dataField: "transaction_remarks",
      text: props.t("Remarks"),
      headerStyle: { width: "9%" },
      footer: true,
    },
    {
      dataField: "running_balance",
      text: props.t("Running"),
      headerStyle: { width: "5%" },
      footer: true,
      hidden: !isOpeningBalance,
    },
  ];

  const handleDownload = () => {
    const fileName = `inventory_transaction_report`;
    const exportType = "xls";

    if (flattenedData?.length > 0) {
      const data = flattenedData?.map((item) => ({
        "Item Name":
          debugType === "product" ? item.product_name : item.product_name,
        Batch: item.batch || "",
        ...(debugType === "item" && { Free: item.is_free ? "Yes" : "No" }),
        ...(debugType === "product"
          ? { "Costing Unit": item.unit_for_cost_price }
          : { "Purchasing Unit": item.unit_for_po }),
        Fromula: item.unit_levels && exportFromula(item.unit_levels),
        Quantity:
          ExportAvailableInCSVForReports(item.transaction_quantity) || "",
        "Cost Price": item.cost_price ? `${item.cost_price.toFixed(2)}` : "",
        "Receiving Cost": item.receiving_cost
          ? `${item.receiving_cost.toFixed(2)}`
          : "",
        "Transaction Date": moment(item.transaction_date).format(
          "DD/MM/YYYY HH:mm",
        ),
        "Transaction Type": item.transaction_type || "",
        Impact: item.impact || "",
        "Running Balance": item.running_balance || "",
        Remarks: item.transaction_remarks || "",
      }));

      exportFromJSON({ data, fileName, exportType });
    }
  };
  const findDuplicateOrders = () => {
    const map = new Map();

    if (allOrders) {
      allOrders.forEach((order) => {
        const quantityString = order.transaction_quantity
          .map((q) => `${q.unit}:${q.value}`)
          .sort()
          .join("|");
        const transaction_date = moment(order.transaction_date).format(
          "YYYY-MM-DD HH:mm",
        );
        const key =
          debugType === "product"
            ? `${order.product_name}-${order.batch}-${order.transaction_remarks}-${quantityString}-${transaction_date}`
            : `${order.item_name}-${order.batch}-${order.transaction_remarks}-${quantityString}-${transaction_date}`;
        // const key = `${order.item_name}-${order.batch}`;
        if (!map.has(key)) {
          map.set(key, []);
        }
        map.get(key).push(order);
      });
    }

    const duplicates = Array.from(map.values()).filter(
      (group) => group.length > 1,
    );
    return duplicates;
  };

  const DuplicateOrdersAlert = ({ duplicates }) => {
    if (!duplicates || duplicates.length === 0) return null;

    return (
      <Card className="mb-3 border border-warning">
        <CardBody>
          <div className="d-flex align-items-center mb-3">
            <i
              className="mdi mdi-alert-circle text-warning mr-2"
              style={{ fontSize: "24px" }}
            ></i>
            <h5 className="mb-0">
              {props.t("Duplicate Transactions Found")} ({duplicates.length}{" "}
              groups)
            </h5>
          </div>
          <div style={{ maxHeight: "300px", overflowY: "auto" }}>
            {duplicates.map((group, index) => (
              <div key={index} className="alert alert-warning mb-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <strong>Duplicate Group {index + 1}</strong>
                  <span className="badge badge-warning">
                    {group.length} identical transactions
                  </span>
                </div>

                <div className="row">
                  {group.map((item, idx) => (
                    <div key={idx} className="col-12 col-md-6 col-lg-4 mb-2">
                      <Card className="border h-100">
                        <CardBody className="p-3">
                          <div className="small">
                            <div className="d-flex justify-content-between mb-2">
                              <strong className="text-primary">
                                {item.item_name}
                              </strong>
                              <span className="text-muted">
                                {moment(item.transaction_date).format(
                                  "DD/MM/YYYY HH:mm:ss",
                                )}
                              </span>
                            </div>

                            <div className="mb-1">
                              <span className="text-muted">Batch:</span>
                              <span className="ml-2 font-weight-medium">
                                {item.batch}
                              </span>
                            </div>

                            <div className="mb-1">
                              <span className="text-muted">Quantity:</span>
                              <span className="ml-2 font-weight-medium">
                                {formatUnitsForReport(
                                  item.transaction_quantity,
                                )}
                              </span>
                            </div>

                            <div className="text-muted">
                              <small>{item.transaction_remarks}</small>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    );
  };

  const transactionOptions = {
    item: [
      { value: "po", label: "Purchase Orders" },
      { value: "itemorder", label: "Item Order" },
      { value: "transfer_inbound", label: "Transfer Inbound" },
      { value: "transfer_outbound", label: "Transfer Outbound" },
      { value: "manual", label: "Manual Entry" },
      { value: "return_credit", label: "Return Credit" },
      { value: "return_debit", label: "Return Debit" },
      { value: "used", label: "Used" },
      { value: "waste", label: "Waste" },
      { value: "discard", label: "Discard" },
      { value: "closure", label: "Closure" },
    ],
    product: [
      { value: "productorder", label: "Product Order" },
      { value: "transfer_inbound", label: "Transfer Inbound" },
      { value: "transfer_outbound", label: "Transfer Outbound" },
      { value: "manual", label: "Manual Entry" },
      { value: "used", label: "Used" },
      { value: "waste", label: "Waste" },
      { value: "discard", label: "Discard" },
      { value: "closure", label: "Closure" },
    ],
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Branch Transaction Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Branch Transaction Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={loadOrders}>
                    <Row>
                      <Col lg={12} className="mb-3">
                        <div className="d-flex justify-content-start align-items-center">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="debugType"
                              id="item"
                              value="item"
                              checked={debugType === "item"}
                              onChange={handleDebugTypeChange}
                            />
                            <label className="form-check-label" htmlFor="item">
                              {/* <i className="mdi mdi-package-variant me-1"></i> */}
                              {props.t("Item Debug")}
                            </label>
                          </div>
                          <div className="form-check form-check-inline ms-3">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="debugType"
                              id="product"
                              value="product"
                              checked={debugType === "product"}
                              onChange={handleDebugTypeChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="product"
                            >
                              {/* <i className="mdi mdi-food me-1"></i> */}
                              {props.t("Product Debug")}
                            </label>
                          </div>
                        </div>
                      </Col>

                      {debugType && (
                        <>
                          <Col lg={2}>
                            <AvField
                              name="branch"
                              label={props.t("Store/Branch")}
                              type="select"
                              value={selectedBranch}
                              onChange={(e) =>
                                setSelectedBranch(e.target.value)
                              }
                              errorMessage={props.t(
                                "Please select store or branch",
                              )}
                              validate={{ required: { value: true } }}
                            >
                              <option value="">{props.t("Select")}</option>
                              {allBranches?.map((branch) => (
                                <option key={branch._id} value={branch._id}>
                                  {branch.name}
                                </option>
                              ))}
                            </AvField>
                          </Col>

                          <Col lg={2}>
                            <AvField
                              name="dateFrom"
                              label={props.t("From Date")}
                              placeholder={props.t("Select")}
                              type="date"
                              value={dateFrom}
                              onChange={(e) => {
                                const selectedDate = e.target.value;
                                setDateFrom(selectedDate);

                                const maxDate = moment(selectedDate)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD");
                                const currentDate =
                                  moment().format("YYYY-MM-DD");

                                if (
                                  moment(dateTo).isAfter(maxDate) ||
                                  moment(dateTo).isAfter(currentDate)
                                ) {
                                  setDateTo(
                                    maxDate > currentDate
                                      ? currentDate
                                      : maxDate,
                                  );
                                }
                              }}
                              max={moment().format("YYYY-MM-DD")}
                              errorMessage={props.t("Date cannot be empty.")}
                              validate={{ required: { value: true } }}
                            />
                          </Col>

                          <Col lg={2}>
                            <AvField
                              name="dateTo"
                              label={props.t("To Date")}
                              placeholder={props.t("Select")}
                              type="date"
                              value={dateTo}
                              onChange={(e) => {
                                const selectedDate = e.target.value;
                                setDateTo(selectedDate);
                              }}
                              min={dateFrom}
                              max={
                                moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD") >
                                moment().format("YYYY-MM-DD")
                                  ? moment().format("YYYY-MM-DD")
                                  : moment(dateFrom)
                                      .add(30, "days")
                                      .format("YYYY-MM-DD")
                              }
                              errorMessage={props.t("Date cannot be empty.")}
                              validate={{ required: { value: true } }}
                            />
                          </Col>

                          <Col lg={2}>
                            <AvField
                              name="method"
                              label={props.t("Transaction Mode")}
                              type="select"
                              value={selectedMethod}
                              onChange={(e) =>
                                setSelectedMethod(e.target.value)
                              }
                            >
                              <option value="">{props.t("All")}</option>
                              {transactionOptions[debugType]?.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {props.t(option.label)}
                                </option>
                              ))}
                            </AvField>
                          </Col>

                          <Col lg={2}>
                            <AvField
                              name="opening_balance_price_total"
                              label={props.t("Opening Balance")}
                              type="text"
                              validate={{
                                required: { value: false },
                                pattern: {
                                  value: "^[0-9]*\\.?[0-9]*$",
                                  errorMessage: props.t(
                                    "Please enter a valid number",
                                  ),
                                },
                                max: {
                                  value: 999999999.99,
                                  errorMessage: props.t("Value is too large"),
                                },
                              }}
                              placeholder={props.t("Enter amount")}
                            />
                          </Col>

                          <Col lg={2}>
                            <Button
                              type="submit"
                              className="btn btn-md btn-success mt-4"
                            >
                              <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                              {props.t("Check")}
                            </Button>
                          </Col>
                        </>
                      )}
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                        disabled={allOrders?.length === 0}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>

                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Store/Branch Transaction Report")}
                    </CardTitle>
                    <DuplicateOrdersAlert duplicates={findDuplicateOrders()} />
                    <Col lg={12} className="text-right fw-bold">
                      Opening Balance : {response?.opening_balance} <br />
                      Closing Balance : {response?.closing_balance}
                    </Col>
                    <ToolkitProvider
                      keyField="id"
                      key={`${dateFrom - dateTo}`}
                      data={allOrders}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            bootstrap4
                            condensed
                            filter={filterFactory({ afterFilter })}
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(DebugPage)),
);
